import {
  BaristaIllustration,
  NoMessagesIllustration,
  PhoneVsDesktopIllustration,
  RelaxationWomanIllustration,
  UmbrellaGuyIllustration,
  TeamworkWhiteboardIllustration,
  YogaWomanIllustration,
} from 'redesign/components/atoms/Illustrations'
import NothingFoundIllustration from 'redesign/components/atoms/Illustrations/nothing-found-illustration'
import RelaxBookWomanIllustration from 'redesign/components/atoms/Illustrations/relax--book-woman-illustration'

export const EMPTY_PAGE_VARIANTS = {
  noPersonalTasks: 'noPersonalTasks',
  noShifts: 'noShifts',
  noEvents: 'noEvents',
  noNewsletter: 'noNewsletter',
  noWiki: 'noWiki',
  noDocuments: 'noDocuments',
  noNotifications: 'noNotifications',
  noPersonsSelected: 'noPersonsSelected',
  noMatchFound: 'noMatchFound',
} as const

export const EMPTY_PAGE_DETAILS = {
  [EMPTY_PAGE_VARIANTS.noPersonalTasks]: {
    illustration: RelaxationWomanIllustration,
    translationKey: 'tasks.empty',
  },
  [EMPTY_PAGE_VARIANTS.noShifts]: {
    illustration: YogaWomanIllustration,
    translationKey: 'shiftPlan.empty',
  },
  [EMPTY_PAGE_VARIANTS.noEvents]: {
    illustration: BaristaIllustration,
    translationKey: 'cmsEvents.empty',
  },
  [EMPTY_PAGE_VARIANTS.noNewsletter]: {
    illustration: NoMessagesIllustration,
    translationKey: 'cmsNewsletters.empty',
  },
  [EMPTY_PAGE_VARIANTS.noWiki]: {
    illustration: UmbrellaGuyIllustration,
    translationKey: 'cmsPages.empty',
  },
  [EMPTY_PAGE_VARIANTS.noDocuments]: {
    illustration: RelaxBookWomanIllustration,
    translationKey: 'documents.empty',
  },
  [EMPTY_PAGE_VARIANTS.noNotifications]: {
    illustration: PhoneVsDesktopIllustration,
    translationKey: 'notifications.empty',
  },
  [EMPTY_PAGE_VARIANTS.noPersonsSelected]: {
    illustration: TeamworkWhiteboardIllustration,
    translationKey: 'persons.empty',
  },
  [EMPTY_PAGE_VARIANTS.noMatchFound]: {
    illustration: NothingFoundIllustration,
    translationKey: 'filters.empty',
  },
  default: {
    illustration: null,
    translationKey: 'No Content Available',
  },
}
